import React, { useEffect } from 'react'
import cx from 'classnames'
import IconButton from '@material-ui/core/IconButton'
import MenuIcon from '@material-ui/icons/Menu'
import CloseIcon from '@material-ui/icons/Close'

const Hamburger = ({
  dataAttributes,
  showNavigation,
  hideNavigation,
  isNavigationVisible,
  deviceType: { isDesktop, isMobile }
}) => {
  useEffect(() => {
    if (isDesktop) {
      hideNavigation()
    }
  }, [isDesktop, hideNavigation])

  return (
    <div className='h-100 dn-d'>
      <IconButton
        {...dataAttributes}
        className={cx('h-100')}
        style={{ fontSize: isMobile ? '2rem' : '2.5rem' }}
        size='small'
        onClick={isNavigationVisible ? hideNavigation : showNavigation}
      >
        {
          isNavigationVisible
            ? <CloseIcon className='black' fontSize='inherit' />
            : <MenuIcon className='black' fontSize='inherit' />
        }
      </IconButton>
    </div>
  )
}

export default Hamburger
